import { render } from "./ServiceOverview.vue?vue&type=template&id=15fd0f36&scoped=true"
import script from "./ServiceOverview.vue?vue&type=script&lang=js"
export * from "./ServiceOverview.vue?vue&type=script&lang=js"

import "./ServiceOverview.vue?vue&type=style&index=0&id=15fd0f36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fd0f36"]])

export default __exports__